import { render, staticRenderFns } from "./Bad.vue?vue&type=template&id=3b0fa021&scoped=true"
import script from "./Bad.vue?vue&type=script&lang=js"
export * from "./Bad.vue?vue&type=script&lang=js"
import style0 from "./Bad.vue?vue&type=style&index=0&id=3b0fa021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0fa021",
  null
  
)

export default component.exports